<div class="wrapper">
  <app-navbar></app-navbar>
  <router-outlet/>
</div>
